import { render, staticRenderFns } from "./prizeRule.vue?vue&type=template&id=49e9fd5b&scoped=true&"
import script from "./prizeRule.vue?vue&type=script&lang=js&"
export * from "./prizeRule.vue?vue&type=script&lang=js&"
import style0 from "./prizeRule.vue?vue&type=style&index=0&id=49e9fd5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9fd5b",
  null
  
)

export default component.exports